export enum TextMergeType {
    PlAIN = "plain",
    MULTI_LINE = "multiline",
    HTML = "html",
    JSON = "json",
    XML = "xml",
}
